<div [className]="collapse == true ? 'input-wrapper collapsed-side-form' : 'input-wrapper'">

    <div class="side-info-table">

        <sem-loader [showLoader]="showLoader"></sem-loader>

        <div class="side-wrapper edit-form-title-wrapper">
            <p class="input-form-title">{{translationsService.translate(title)}}</p>
        </div>
    </div>

    <div class="l-cont-separator"></div>

    <p (click)="setSnapshot('0')" class="inner-html-comp snap-ver"><span class=s-blue></span> Trenutna verzija</p>
    @for (item of model.Snapshots; track $index) {
        <p (click)="setSnapshot(item.Body)" class="inner-html-comp snap-ver"><span class=s-blue></span> {{item.Title}}</p>
    }


</div>